import "./ContactItem.css";

const ContactItem = ({ data }) => {
	return (
		<div className="contact-item-container">
			<div className="contact-item-icon-container">
				<div className="contact-item-image-bg" title={data["title"]}>
					<img
						alt={data["alt"]}
						src={require("../../../assets/" + data["icon"])}
						className="contact-item-image"
					/>
				</div>
			</div>
			<div className="contact-item-texts">
				<h4
					className="h4-bold contact-item-title"
					style={{ margin: "0 0 4px 0" }}
				>
					{data["title"]}
				</h4>
				<h5 style={{ margin: 0 }}>{data["description"]}</h5>
			</div>
		</div>
	);
};

export default ContactItem;
